import StaticContentsContainer from '../../components/StaticContentsContainer';
import ResultBox from './ResultBox';
import { ANSWER_KEY, getTestList, orderedTest, setSubmissionNum } from '../../constants';
import { saveScore } from '../../../../../api/submission';

function TestResult() {
    const container = StaticContentsContainer();
    container.classList.add('test-result-container');
    const scoredTest = [...orderedTest].filter(test => typeof test.conversionFactor === 'number');

    const testList = getTestList();
    const results = scoredTest.reduce((acc, test) => {
        const completedTest = testList.find(progressedTest => progressedTest.key === test.key);
        // acc[SCORE_KEY[test.key]] = completedTest ? calcTotalScore(completedTest) : null;
        acc[ANSWER_KEY[test.key]] = completedTest
            ? completedTest.selectedAnswers.filter((selected, i) => !(selected === 0 && i === 0))
            : [];

        return acc;
    }, {});

    saveScore({ answers: results })
        .then(result => {
            if (result?.data?.pkValue) {
                setSubmissionNum(result.data.pkValue);
            }
        })
        .catch(console.error);

    container.append(
        ...scoredTest.map(test => {
            const completedTest = testList.find(progressedTest => progressedTest.key === test.key);
            if (completedTest) {
                return ResultBox(completedTest);
            }
            return ResultBox(test, true);
        }),
    );

    return container;
}

export const calcTotalScore = test =>
    Math.round(test.totalScore.reduce((acc, cur) => acc + cur, 0) * test.conversionFactor * 10) / 10;

export default TestResult;
